import CloseIcon from '@mui/icons-material/Close';
import { Divider, Modal, Stack } from '@mui/material';

import InformIndividualDialog from './informedIndividualDialog';
import {  ButtonAction, CardWrapper } from './styled-components';

interface DeleteDialogProps {
  handleClose: () => void,
  open: boolean,
  dialogTitle: string,
  content: React.JSX.Element,
  footer: React.JSX.Element
}


const DeleteDialog = ({ open, handleClose, dialogTitle, content, footer }: DeleteDialogProps) => {

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <CardWrapper sx={{ minHeight: '180px !important' }}>
        <>
          <Stack width="100%" direction="column">
            <Stack width="100%" sx={{ bgcolor: '#FFFFFF', p: '14px' }} direction="row" justifyContent="space-between">
              <InformIndividualDialog.title>{dialogTitle}</InformIndividualDialog.title>
              <ButtonAction onClick={handleClose} sx={{ color: '#878787' }}>
                <CloseIcon fontSize="small" />
              </ButtonAction>
            </Stack>
            <Divider />
          </Stack>
          <Stack width="100%" direction="column" sx={{ padding: '16px ' }}>
            {
              content
            }
          </Stack>
          <Divider></Divider>
          <Stack sx={{ paddingBottom: '16px', paddingRight: '16px', paddingTop: '16px' }} justifyContent="flex-end" width="100%" direction="row">
            { footer }
          </Stack>
        </>
            
      </CardWrapper>
    </Modal>
  );
};

export default DeleteDialog;